export default "__VITE_ASSET__D$r8APGJ__"